import React, { useEffect, useCallback } from 'react';
import { addMinutes, subMinutes } from 'date-fns';

const KeyboardControls = ({ 
  onTimeChange, 
  currentDateTime,
  isPlaying,
  onPlayStateChange
}) => {
  const handleKeyDown = useCallback((event) => {
    // Skip handling if focus is on input elements
    if (
      document.activeElement.tagName === 'INPUT' || 
      document.activeElement.tagName === 'TEXTAREA' ||
      document.activeElement.tagName === 'SELECT'
    ) {
      return;
    }

    switch (event.key) {
      // Using different keys to avoid conflict with Mapbox arrow keys
      
      // 'D' for advancing 1 minute (right)
      case 'd':
      case 'D':
        event.preventDefault();
        const newDateTime = addMinutes(currentDateTime, 1);
        onTimeChange(newDateTime);
        break;
        
      // 'A' for going back 1 minute (left)
      case 'a':
      case 'A':
        event.preventDefault();
        const prevDateTime = subMinutes(currentDateTime, 1);
        onTimeChange(prevDateTime);
        break;

      // Space to toggle play/pause (if provided)
      case ' ':
        if (onPlayStateChange) {
          event.preventDefault();
          onPlayStateChange(!isPlaying);
        }
        break;
        
      // 'W' for advancing 10 minutes (up)
      case 'w':
      case 'W':
        event.preventDefault();
        const jumpForwardDateTime = addMinutes(currentDateTime, 10);
        onTimeChange(jumpForwardDateTime);
        break;
        
      // 'S' for going back 10 minutes (down)
      case 's':
      case 'S':
        event.preventDefault();
        const jumpBackDateTime = subMinutes(currentDateTime, 10);
        onTimeChange(jumpBackDateTime);
        break;
        
      default:
        break;
    }
  }, [onTimeChange, currentDateTime, onPlayStateChange, isPlaying]);

  useEffect(() => {
    // Add event listener
    document.addEventListener('keydown', handleKeyDown);

    // Clean up the event listener
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);

  // This component doesn't render anything
  return null;
};

export default KeyboardControls;